import React from 'react';
import { capitalize } from '../../utils/strings';
import { Loader } from '../../components/Loader/Loader';
import {
  FaFlag,
  FaLock,
  FaPencilAlt,
  FaRegCopy,
  FaUnlockAlt,
} from 'react-icons/fa';
import { User } from '../../types/userTypes';
import { formatPhoneNumber } from '../../utils/formatting';
import { formatTime, travelMode } from './Users';

export function UsersTable({
  users,
  loading,
  userSelected,
  userPhoneCopied,
  userPhoneCopyMethod,
}: {
  userSelected: (user: User) => void;
  userPhoneCopied?: string | null;
  loading: boolean;
  users: User[];
  userPhoneCopyMethod: (user: User) => void;
}): JSX.Element {
  return (
    <>
      <table className="user-list__table">
        <thead>
          <tr>
            <th>Role</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Last signed in</th>
            <th>
              <FaFlag />
            </th>
            <th>
              <FaUnlockAlt />
            </th>
          </tr>
        </thead>
        <tbody>
          {!loading &&
            users.map((user: User, idx: number) => (
              <tr
                key={`${user.email}`}
                onClick={() => userSelected(user)}
                className={
                  user.isLocked ? 'user-list__table--locked' : undefined
                }
              >
                <td>
                  <span className="user-list__table--role">
                    {capitalize(user.role).replace('_', ' ')} {travelMode(user)}
                    {user.predictionModel !== 'DISPATCHER' ? 'T' : ''}
                  </span>
                </td>
                <td>
                  {user.fullName()}
                  <span className="user-list__table--edit">
                    <FaPencilAlt />
                  </span>
                </td>
                <td>{user.email}</td>
                <td
                  onClick={e => {
                    e.stopPropagation();
                    if (navigator.clipboard && navigator.clipboard.writeText) {
                      navigator.clipboard.writeText(user.phoneNumber);
                      userPhoneCopyMethod(user);
                    }
                  }}
                  className={
                    userPhoneCopied === user.email
                      ? 'user-list__table--copied'
                      : ''
                  }
                >
                  {userPhoneCopied !== user.email && (
                    <>
                      {formatPhoneNumber(user.phoneCode + user.phoneNumber)}{' '}
                      <span>
                        <FaRegCopy />
                      </span>
                    </>
                  )}
                  {userPhoneCopied === user.email && <span>Phone copied!</span>}
                </td>
                <td>{formatTime(user.lastSignedIn)}</td>
                <td>{user.country}</td>
                <td>
                  {user.isLocked && (
                    <span>
                      <FaLock />
                    </span>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {!loading && users.length === 0 && (
        <div className="user-list__table-message">No users found.</div>
      )}
      {loading && (
        <div className="user-list__table-loader">
          <Loader type="bounce" size="xxl" />
        </div>
      )}
    </>
  );
}
